<template>
<!-- <CompanyPolicy></CompanyPolicy> -->
  
  <div class="col-xxl-12  mb-5">
    <!-- <BalanceDetails
      widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
    ></BalanceDetails> -->
  </div>
  <div class="col-xxl-12">
    <TransactionHistory
      widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
    ></TransactionHistory>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { config } from "@/core/helpers/config";
import { themeName } from "@/core/helpers/documentation";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import TransactionHistory from "@/components/transactions/TransactionHistory.vue";
// import BalanceDetails from "@/components/cards/BalanceDetails.vue";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";


export default defineComponent({
  name: "transactions",
  components: {
    TransactionHistory,
    // BalanceDetails,
    // CompanyPolicy,
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("transactionsTab") || "0");

      setCurrentPageTitle("Transactions");
    });

    /**
     * Reset config
     * @param event
     */
    const reset = event => {
      event.preventDefault();
      // remove existing saved config
      localStorage.removeItem("config");
      window.location.reload();
    };

    /**
     * Set active tab when the tab get clicked
     * @param event
     */
    const setActiveTab = event => {
      tabIndex.value = parseInt(event.target.getAttribute("data-tab-index"));
      // keep active tab
      localStorage.setItem("transactionsTab", tabIndex.value.toString());
    };

    /**
     * Submit form
     * @param event
     */
    const submit = event => {
      event.preventDefault();
      // save new config to localStorage
      localStorage.setItem("config", JSON.stringify(config.value));
      window.location.reload();
    };

    return {
      tabIndex,
      config,
      reset,
      setActiveTab,
      submit,
      themeName
    };
  }
});
</script>
